import { inject } from 'vue'
import { contextMenuInjectionKey } from './context'
import type { ContextMenuProvider } from './types'

function useContextMenu() {
  const provider = inject<ContextMenuProvider>(contextMenuInjectionKey)

  if (!provider) {
    throw new Error('No outer <ContextMenuProvider /> founded.')
  }

  return provider
}

export default useContextMenu
